import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  Input,
  OnDestroy,
  ViewEncapsulation
} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'int-field-box',
  templateUrl: './int-field-box.component.html',
  styleUrls: ['./int-field-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntFieldBoxComponent implements OnDestroy {

  focus$ = new BehaviorSubject(false);
  error$ = new BehaviorSubject(false);

  @Input() set isFocus(status: boolean) {
    this.focus$.next(Boolean(status));
  }

  @Input() set isError(status: boolean) {
    this.error$.next(Boolean(status));
  }

  constructor(
    public cdr: ChangeDetectorRef,
    readonly elementRef: ElementRef
  ) {
  }

  get isFocus(): boolean {
    return Boolean(this.focus$.value);
  }

  get isError(): boolean {
    return Boolean(this.error$.value);
  }

  setFocus() {
    this.focus$.next(true);
    this.cdr.markForCheck()
  }

  setBlur() {
    this.focus$.next(false);
  }

  ngOnDestroy() {
    this.focus$.next(false);
    this.focus$.complete();
  }

}
